import styled from "styled-components";
import { ColorOptions } from "@/src/types";
import { MainInner, StyledMainSection } from "@/styles/global";

type StyleProps = {
  $backgroundColor: ColorOptions;
  $backgroundType: "card" | "fill";
  $left?: boolean;
};

const Section = styled(StyledMainSection)``;

const Inner = styled(MainInner)<StyleProps>`
  ${({ $backgroundType, $backgroundColor, theme }) =>
    $backgroundType === "fill"
      ? `background-color: ${theme.colors[$backgroundColor]};`
      : ""};
`;

const Card = styled.div<StyleProps>`
  display: flex;
  padding: ${({ $backgroundType }) =>
    $backgroundType === "fill" ? "23px 0px" : "23px 16px"};
  border-radius: 21px;
  background-color: ${({ theme, $backgroundColor }) =>
    theme.colors[$backgroundColor]};
  flex-direction: ${({ $left }) => ($left ? "column-reverse" : "column")};
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    flex-direction: ${({ $left }) => ($left ? "row-reverse" : "row")};
    padding: ${({ $backgroundType }) =>
      $backgroundType === "fill" ? "40px 0px" : "40px 48px"};
    gap: 72px;
  }
`;

const ImageWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    max-width: 30%;
  }
`;

const S = {
  Section,
  Inner,
  Card,
  ImageWrapper,
};

export default S;
